export default "__VITE_ASSET__C7IL_qRy__"